import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Typography from '../../typography';
import RenOverflowingText from '../../ren-overflowing-text';

const renOverflowingTextWrapper = ({ data, accessor, columnData }) => (
  <RenOverflowingText
    value={data[accessor]}
    textProps={columnData?.textProps}
  />
);

renOverflowingTextWrapper.defaultProps = {
  data: {},
  accessor: '',
  columnData: {},
};

renOverflowingTextWrapper.propTypes = {
  data: PropTypes.shape({}),
  accessor: PropTypes.string,
  columnData: PropTypes.shape({
    textProps: PropTypes.shape({ ...Typography.propTypes }),
  }),
};

export default memo(renOverflowingTextWrapper);
